module.exports = __webpack_public_path__ + "static/media/iq.e1922026.svg";